import type { ReactNode } from 'react';
import { BrandMark } from '@/ui/Icon';

// The calm full-screen backdrop behind sign-in, invitations and start-up: the canvas with soft accent light
// and one centred card.

export function AuthFrame({ children, label }: { children: ReactNode; label: string }) {
  return (
    <main className="auth" aria-label={label}>
      <div className="auth-wrap">{children}</div>
    </main>
  );
}

/** The mark, the product name and the workspace it belongs to, at the top of an auth card. */
export function AuthBrand({ workspaceName }: { workspaceName?: string | null }) {
  return (
    <div className="auth-brand">
      <BrandMark />
      <div>
        <b>Clientbook</b>
        {workspaceName ? <span>{workspaceName}</span> : null}
      </div>
    </div>
  );
}
